'use es6';

import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { OrderedSet } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import identity from 'transmute/identity';
import FilterType from './propTypes/FilterType';
import { getDisabledFilterFamilies } from '../utilities/addingCondition';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterFamilySelect = props => {
  const {
    activeGroup,
    getFilterFamilyName,
    onClick,
    options
  } = props;
  const disabledOptions = getDisabledFilterFamilies(activeGroup);
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex flex-column flex-grow-1",
    children: options.map(filterFamily => {
      return /*#__PURE__*/_jsx(UITooltip, {
        disabled: !disabledOptions[filterFamily],
        placement: "bottom",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditorOperatorCreate.duplicateFilterFamilyMessage"
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx(UIRadioInput, {
          "data-selenium-info": filterFamily,
          "data-selenium-test": "XOFilterEditor-filterfamily-option",
          disabled: disabledOptions[filterFamily],
          name: filterFamily,
          onChange: onClick,
          children: getFilterFamilyName(filterFamily)
        }, filterFamily)
      }, filterFamily);
    })
  });
};
FilterFamilySelect.propTypes = {
  activeGroup: FilterType.isRequired,
  getFilterFamilyName: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  options: ImmutablePropTypes.orderedSetOf(PropTypes.string).isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
FilterFamilySelect.defaultProps = {
  getFilterFamilyName: identity,
  options: OrderedSet([CONTACT])
};
export default FilterFamilySelect;